module.exports = __webpack_public_path__ + "static/media/seated_leg_curl_machine.af6a1c8e.png";